import Table from "@/components/Table/table";
import { useColumnTaskDefs } from "@/features/claimsummary/summary/constant/claimFormHeaderConst";
import {
  useGetTaskByIdApiDataQuery,
  useGetTaskViewDataQuery,
  useDeleteClaimTaskMutation,
} from "@/services/claimSummary/caseSummaryReducer";
import {
  MotifButton,
  MotifIcon,
  MotifModal,
  MotifModalBody,
  MotifModalFooter,
  MotifModalHeader,
  MotifProgressLoader,
} from "@ey-xd/motif-react";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { CreateTaskAllInputFields } from "./createTaskAllInputs";
import { IconoirWarningTriangle } from "@ey-xd/motif-icon";
import { EditTaskAllInputFields } from "./EditTaskAllInputs";
import { useCase } from "@/features/case/use-case";
import ConfirmationModal from "@/components/Modal/ConfirmationModal/ConfirmationModal";
import { useTranslation } from "react-i18next";
import {
  getOnlyDate,
  getTaskTypeName,
  havingAddPermission,
  havingDeletePermission,
  havingEditPermission,
} from "@/utility/common";
import { useSelector } from "react-redux";
import {
  APPLY_BUTTON_VARIANT,
  CANCEL_BUTTON_VARIANT,
  CONFIRM_BUTTON_VARIANT,
  CREATE_BUTTON_VARIANT,
  GetCommonDeleteImgButton,
} from "@/components/Images/CommonImages";
import { useTrans } from "@/components/Functions/dateFunc";
import FormattedDatePicker from "@/components/FormattedDatePicker/FormattedDatePicker";
import { END_OF_DAY_TIME, START_OF_DAY_TIME } from "@/Constant";
type taskConst = {
  data: {
    name: string;
    taskDueDate: string;
    status: number;
    type: number;
    createdOn: string;
    createdBy: string;
    action: string;
    id: string;
  };
};
export const useCustomCellRenderers = (
  setClaimTaskId: any,
  setDeleteModal: any,
  setEditTask: any,
  setShowModal: any,
  ClaimTask: string[],
  setClaimTaskName: any
) => {
  const { t } = useTranslation();
  const customActionHeader = {
    taskCellRenderer: function (param: taskConst) {
      return (
        <div
          className={
            havingEditPermission(ClaimTask) ? "text-bold-underline" : ""
          }
          style={
            havingEditPermission(ClaimTask)
              ? { cursor: "pointer" }
              : { cursor: "default" }
          }
          onClick={() => {
            if (havingEditPermission(ClaimTask)) {
              setClaimTaskId(param.data.id);
              setEditTask(true);
              setShowModal(true);
            }
          }}
        >
          {param?.data?.name || ""}
        </div>
      );
    },
    statusRenderer: function (param: taskConst) {
      return (
        <>
          {param.data.status === 0 ? (
            <>Open</>
          ) : param.data.status === 1 ? (
            <>Closed</>
          ) : (
            <>Completed</>
          )}
        </>
      );
    },
    actionRenderer: function (param: taskConst) {
      return (
        <>
          {/* { havingEditPermission(ClaimTask) && 
          <MotifButton
            size="small"
            type="submit"
            variant="secondary"
            style={{ padding: "0px 8px" }}
            onClick={() => {
              setClaimTaskId(param.data.id);
              setEditTask(true);
              setShowModal(true);
            }}
          >
            <MotifIcon
              iconFunction={IconoirEditPencil}
              stroke="blue"
              strokeWidth="2"
              size="20"
            />
          </MotifButton>
          }
          &nbsp;&nbsp; */}
          {
            havingDeletePermission(ClaimTask) && (
              <GetCommonDeleteImgButton
                onClick={() => {
                  setClaimTaskId(param.data.id);
                  setDeleteModal(true);
                  setClaimTaskName(param.data.name);
                }}
              ></GetCommonDeleteImgButton>
            )
            // <CommonTooltipWrapper tooltipTitle={t("global.globalActions.delete")}>
            // <MotifButton
            //   size="small"
            //   type="submit"
            //   variant="secondary"
            //   style={{ padding: "0px 8px" }}
            //   onClick={() => {
            //     setClaimTaskId(param.data.id);
            //     setDeleteModal(true);
            //     setClaimTaskName(param.data.name);
            //   }}
            // >
            //   <MotifIcon
            //     iconFunction={IconoirTrash}
            //     stroke="blue"
            //     strokeWidth="2"
            //     size="20"
            //   />
            // </MotifButton>
            // </CommonTooltipWrapper>
          }
        </>
      );
    },
    typeRenderer: function (param: taskConst) {
      return <>{t(getTaskTypeName(param.data.type))}</>;
    },
  };
  return customActionHeader;
};

export const Tasks = () => {
  const { t } = useTranslation();
  const parameter = useParams();
  const [showModal, setShowModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [editTask, setEditTask] = useState(false);
  const [claimTaskId, setClaimTaskId] = useState();
  const [claimTastName, setClaimTaskName] = useState();
  const caseData = useCase();
  const [isDiscardVisible, setIsDiscardVisible] = useState(false);
  function handleReject(flag: any) {
    setShowModal(flag);
  }
  const [basicSearchData, setBasicSearchData] = useState<{
    startDate: Date | undefined | null;
    endDate: Date | undefined | null;
  }>({ startDate: null, endDate: null });
  const [showBasicSearch, setShowBasicSearch] = useState(false);
  const columnTaskDefs = useColumnTaskDefs(caseData?.abbreviation);
  const permissions = useSelector((state: any) => state.permissions);
  const { ClaimTask } = permissions;
  let [discardMessageTrig, setDiscardMessage] = useState(false);
  const {
    data: getTaskById,
    isFetching: dataIsLoading,
    error: errorData,
  } = useGetTaskByIdApiDataQuery(claimTaskId, {
    skip: !claimTaskId,
  });
  const caseRenderers = useCustomCellRenderers(
    setClaimTaskId,
    setDeleteModal,
    setEditTask,
    setShowModal,
    ClaimTask,
    setClaimTaskName
  );
  // @ts-ignore
  const getDataByUrl = { caseId: caseData.caseId, claimId: parameter?.claimId };
  const { data, isLoading, refetch } = useGetTaskViewDataQuery(getDataByUrl);
  const [deleteClaimTask, { isLoading: deleteLoading }] =
    useDeleteClaimTaskMutation();
  const filteredTaskData =
    basicSearchData.startDate || basicSearchData.endDate
      ? filterData(data)
      : data;
  function filterData(data: any) {
    return data?.filter((item: any) => {
      const itemDate = new Date(item.createdOn);
      const startDate = basicSearchData.startDate
        ? new Date(
            `${getOnlyDate(basicSearchData.startDate)} ${START_OF_DAY_TIME}`
          )
        : null;
      const endDate = basicSearchData.endDate
        ? new Date(`${getOnlyDate(basicSearchData.endDate)} ${END_OF_DAY_TIME}`)
        : null;

      if (startDate && endDate) {
        return itemDate >= startDate && itemDate <= endDate;
      }
      if (startDate) {
        return itemDate >= startDate;
      }
      if (endDate) {
        return itemDate <= endDate;
      }
      return false;
    });
  }
  async function deleteClaimItem() {
    let jsonData = {
      claimTaskId: claimTaskId,
    };
    const response = await deleteClaimTask(jsonData);
    if (response.hasOwnProperty("data")) {
      setDeleteModal(false);
      refetch();
    } else {
      setDeleteModal(false);
      refetch();
    }
  }
  const transFunction = useTrans(
    t,
    t("pages.claims.taskTab.deleteMessage", {
      claimTastName: claimTastName,
    }),
    "claimTastName"
  );
  function TitleComplement() {
    return (
      <div className="display-flex ">
        {!showBasicSearch && (
          <MotifButton
            onClick={() => {
              setShowBasicSearch((previous) => !previous);
            }}
            className="mar-r-10"
            variant={CREATE_BUTTON_VARIANT}
          >
            {basicSearchData.startDate || basicSearchData.endDate
              ? t("pages.claims.taskTab.editBasicSearch")
              : t("pages.claims.taskTab.basicSearch")}
          </MotifButton>
        )}
        {!showBasicSearch &&
          (basicSearchData.startDate || basicSearchData.endDate) && (
            <MotifButton
              onClick={() => {
                setBasicSearchData({ startDate: null, endDate: null });
              }}
              className="mar-r-10"
              variant={CREATE_BUTTON_VARIANT}
            >
              {t("pages.claims.taskTab.clearBasicSearch")}
            </MotifButton>
          )}
        {havingAddPermission(ClaimTask) && (
          <MotifButton
            onClick={() => {
              setShowModal(true);
              setEditTask(false);
            }}
            size="small"
            type="submit"
            variant={CREATE_BUTTON_VARIANT}
          >
            {t("pages.claims.taskTab.addTask")}
          </MotifButton>
        )}
      </div>
    );
  }
  return (
    <div className="mar-b-20">
      <MotifModal
        onClose={() => setDeleteModal(false)}
        show={deleteModal}
        focusTrapOptions={{
          tabbableOptions: {
            displayCheck: "none",
          },
        }}
      >
        <div className="confirmationModalWrapper creditor_disabling_model">
          <MotifModalHeader
            headerIcon={
              <>
                <span
                  style={{
                    backgroundColor: "rgb(252, 245, 243)",
                    borderRadius: "50px",
                    padding: "5px 8px 2px 8px",
                  }}
                >
                  <MotifIcon
                    iconFunction={IconoirWarningTriangle}
                    strokeWidth="1"
                    size="15"
                    stroke="red"
                  />{" "}
                </span>
                <span
                  style={{
                    fontSize: 16,
                    display: "block",
                    width: "100%",
                    marginLeft: "10px",
                  }}
                >
                  {t("global.globalNotifications.warning")}
                </span>
              </>
            }
          ></MotifModalHeader>

          <MotifModalBody style={{ paddingTop: "0px" }}>
            <span style={{ fontWeight: "300" }}>{transFunction}</span>
          </MotifModalBody>
          <MotifModalFooter>
            <MotifButton
              size="small"
              type="submit"
              variant={CONFIRM_BUTTON_VARIANT}
              style={{
                border: "1px solid #ccc",
                borderRadius: "4px",
              }}
              onClick={deleteClaimItem}
              loading={deleteLoading}
            >
              {t("global.globalActions.confirm")}
            </MotifButton>

            <MotifButton
              className=""
              onClick={() => setDeleteModal(false)}
              size="small"
              type="button"
              variant={CANCEL_BUTTON_VARIANT}
            >
              {t("global.globalActions.cancel")}
            </MotifButton>
          </MotifModalFooter>
        </div>
      </MotifModal>
      <MotifModal
        onClose={() => {
          if (discardMessageTrig) {
            setIsDiscardVisible(true);
          } else {
            setShowModal(false);
          }
        }}
        show={showModal}
        size={"md"}
        focusTrapOptions={{
          tabbableOptions: {
            displayCheck: "none",
          },
        }}
      >
        <MotifModalHeader>
          {!editTask
            ? t("pages.claims.taskTab.addNewTask")
            : t("pages.claims.taskTab.editTask")}
        </MotifModalHeader>
        <div className="confirmationModalWrapper creditor_disabling_model">
          <MotifModalBody style={{ paddingTop: "20px" }}>
            {!editTask ? (
              <CreateTaskAllInputFields
                setShowModal={handleReject}
                setDiscardMessage={setDiscardMessage}
              />
            ) : (
              <EditTaskAllInputFields
                setShowModal={handleReject}
                getTaskById={getTaskById}
                setDiscardMessage={setDiscardMessage}
                dataIsLoading={dataIsLoading}
                setClaimTaskId={setClaimTaskId}
                errorData={errorData}
              />
            )}
          </MotifModalBody>
        </div>
      </MotifModal>
      {isLoading ? (
        <MotifProgressLoader show variant="default" className="mar-b-20" />
      ) : (
        <div className={showBasicSearch ? " hide_claims_table" : ""}>
          <Table
            columnDefs={columnTaskDefs}
            cellRenderers={filteredTaskData}
            TitleComplement={TitleComplement}
            title={"pages.claims.taskTab.title"}
            description={"pages.claims.taskTab.description"}
            caseRenderers={caseRenderers}
            pagination={false}
            overlayNoRowsTemplate={t("global.globalNotifications.noRecords")}
          />
          {showBasicSearch && (
            <div className="claim-task-filter">
              <div className="motif-row align-items-end">
                <div className="motif-col-lg-4">
                  <div className="formFieldLabel">
                    <label>
                      {t("pages.claims.taskTab.createdOnStartDate")}
                    </label>
                  </div>{" "}
                  <FormattedDatePicker
                    onChange={(value: any) => {
                      setBasicSearchData((prev) => ({
                        ...prev,
                        startDate: value,
                      }));
                    }}
                    required={true}
                    value={basicSearchData.startDate}
                    range={false}
                    maxDate={basicSearchData.endDate || undefined}
                  />
                </div>

                <div className="motif-col-lg-4">
                  <div className="formFieldLabel">
                    <label>{t("pages.claims.taskTab.createdOnEndDate")}</label>
                  </div>{" "}
                  <FormattedDatePicker
                    onChange={(value: any) => {
                      setBasicSearchData((prev) => ({
                        ...prev,
                        endDate: value,
                      }));
                    }}
                    required={true}
                    value={basicSearchData.endDate}
                    range={false}
                    minDate={basicSearchData.startDate || undefined}
                  />
                </div>
                <div className="motif-col-lg-4 display-flex justify-content-center ">
                  <MotifButton
                    onClick={() => {
                      setShowBasicSearch(false);
                      setBasicSearchData({ startDate: null, endDate: null });
                    }}
                    variant={CANCEL_BUTTON_VARIANT}
                    className="mar-r-10"
                  >
                    {t("global.globalActions.cancel")}
                  </MotifButton>
                  <MotifButton
                    onClick={() => {
                      setShowBasicSearch(false);
                    }}
                    variant={APPLY_BUTTON_VARIANT}
                  >
                    {t("global.globalActions.apply")}
                  </MotifButton>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
      <ConfirmationModal
        isVisible={isDiscardVisible}
        setIsVisible={setIsDiscardVisible}
        cancelBtnApproveHandler={() => {
          setShowModal(false);
          setIsDiscardVisible(false);
        }}
        cancelBtnRejectHandler={() => setIsDiscardVisible(false)}
      />
    </div>
  );
};
